import React from 'react';

const MarketInformation = ({ productInfo }) => {
  if (!productInfo) return <div>No product information available.</div>;
  
  // Field configuration - easy to maintain and extend
  const fields = [
    { key: 'marketRegion', label: 'Market Region' },
    { key: 'marketCountry', label: 'Market Country' },
    { key: 'lineOfBusiness', label: 'Line of Business' }
  ];

  // Helper function to render a table row
  const renderField = (field) => {
    const value = productInfo[field.key];
    
    // Handle array values for marketRegion and marketCountry
    const renderValue = (val) => {
      if (Array.isArray(val)) {
        return val.join(', ');
      }
      return val || 'N/A';
    };
    
    return (
      <tr key={field.key} className="hover:bg-gray-50 transition-colors">
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
          {field.label}
        </td>
        <td className="px-6 py-4 text-sm text-gray-700">
          {field.specialRender ? field.specialRender(value) : renderValue(value)}
        </td>
      </tr>
    );
  };
  
  return (
    <div>
      <h3 className="text-xl font-bold text-gray-800 mb-4">Market Information</h3>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-[#FF3C14]">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Label</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Value</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {fields.map(renderField)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarketInformation; 